/** Identifica el dispositivo en la lista de sesiones del servidor. */
export function currentDevice(): string {
  const agent = typeof navigator === 'undefined' ? '' : navigator.userAgent;
  return (agent || 'Navegador').slice(0, 100);
}
